import aliExpress from '@/assets/images/shops/ali-express.svg';
import amazon from '@/assets/images/shops/amazon.svg';
import apple from '@/assets/images/shops/apple.svg';
import barnesNoble from '@/assets/images/shops/barnes-noble.svg';
import bestBuy from '@/assets/images/shops/best-buy.svg';
import costco from '@/assets/images/shops/costco.svg';
import cvs from '@/assets/images/shops/cvs.svg';
import gap from '@/assets/images/shops/gap.svg';
import hm from '@/assets/images/shops/h-m.svg';
import homeDepot from '@/assets/images/shops/home-depot.svg';
import kohl from '@/assets/images/shops/kohl.svg';
import lowe from '@/assets/images/shops/lowe.svg';
import lululemon from '@/assets/images/shops/lululemon.svg';
import macy from '@/assets/images/shops/macy.svg';
import nordstrom from '@/assets/images/shops/nordstrom.svg';
import petco from '@/assets/images/shops/petco.svg';
import samClub from '@/assets/images/shops/sam-club.svg';
import sephora from '@/assets/images/shops/sephora.svg';
import target from '@/assets/images/shops/target.svg';
import temu from '@/assets/images/shops/temu.svg';
import tlmaxx from '@/assets/images/shops/tlmaxx.svg';
import ultaBeauty from '@/assets/images/shops/ulta-beauty.svg';
import walgreens from '@/assets/images/shops/walgreens.svg';
import walmart from '@/assets/images/shops/walmart.svg';
import williamsSonoma from '@/assets/images/shops/williams-sonoma.svg';
import zara from '@/assets/images/shops/zara.svg';

export const SHOPS = [
  {
    image: amazon,
    name: 'Amazon',
  },
  {
    image: walmart,
    name: 'Walmart',
  },
  {
    image: apple,
    name: 'Apple',
  },
  {
    image: target,
    name: 'Target',
  },
  {
    image: temu,
    name: 'Temu',
  },
  {
    image: homeDepot,
    name: 'The Home Depot',
  },
  {
    image: bestBuy,
    name: 'Best Buy',
  },
  {
    image: samClub,
    name: 'Sam’s Club',
  },
  {
    image: nordstrom,
    name: 'Nordstrom',
  },
  {
    image: costco,
    name: 'Costco',
  },
  {
    image: walgreens,
    name: 'Walgreens',
  },
  {
    image: lowe,
    name: 'Lowe’s',
  },
  {
    image: macy,
    name: 'Macy’s',
  },
  {
    image: zara,
    name: 'ZARA',
  },
  {
    image: hm,
    name: 'H&M',
  },
  {
    image: kohl,
    name: 'Kohl’s',
  },
  {
    image: williamsSonoma,
    name: 'Williams–Sonoma',
  },
  {
    image: tlmaxx,
    name: 'TJMaxx',
  },
  {
    image: petco,
    name: 'Petco',
  },
  {
    image: ultaBeauty,
    name: 'Ulta Beauty',
  },
  {
    image: sephora,
    name: 'Sephora',
  },
  {
    image: barnesNoble,
    name: 'Barnes & Noble',
  },
  {
    image: cvs,
    name: 'CVS',
  },
  {
    image: gap,
    name: 'Gap',
  },
  {
    image: aliExpress,
    name: 'Aliexpress',
  },
  {
    image: lululemon,
    name: 'Lululemon',
  },
];
